import ReactGA from 'react-ga';

export function TrackEvent_GA(action, category) {
	ReactGA.event({
		category: category,
		action: action
	});
}


// WEBPACK FOOTER //
// ./src/helpers/analytics.js